export const DELETE_FAVORITE_CONTACT_ID = 'DELETE_FAVORITE_CONTACT_ID';
export const ADD_FAVORITE_CONTACT_ID = 'ADD_FAVORITE_CONTACT_ID';
export const SET_FAVORITE_CONTACT_DATA = 'SET_FAVORITE_CONTACT_DATA';
